module.exports = __webpack_public_path__ + "img/logo-CQE.6291cc19.png";